<template>
  <v-form v-model="isRouteInfoValid" onSubmit="return false;">
    <v-card>
      <v-card-title primary-title>
        <h1>Actualizar Datos de la Ruta</h1>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              name="label"
              label="Nombre Ruta"
              id="id"
              v-model="routeData.description"
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-menu
              ref="menuDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              >
              <template slot="activator">
                <v-text-field
                  v-model="selectedDate"
                  label="Fecha ruta"
                  prepend-icon="event"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedDate"
                no-title
                scrollable
                locale="es-MX"
                >
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menuDate = false">Cancelar</v-btn>
                <v-btn flat color="primary" @click="$refs.menuDate.save(selectedDate)">Seleccionar</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              name="label"
              label="Costo Material"
              id="id"
              v-model="routeData.material_expenses"
              type="number"
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
              name="label"
              label="Viaticos"
              id="id"
              v-model="routeData.viatic_expenses"
              type="number"
            ></v-text-field>
          </v-flex>
           <v-flex xs6>
            <v-text-field
              name="label"
              label="Comisiones"
              id="id"
              v-model="routeData.comission_expenses"
              type="number"
            ></v-text-field>
          </v-flex>
        </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" flat @click="$emit('close-route-dialog')">Cancelar</v-btn>
        <v-btn color="success" @click="updateRoute" :disabled="!isRouteInfoValid">Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>

import moment from 'moment';

export default {
  props: ['selectedRoute'],
  data() {
    return {
      isRouteInfoValid: true,
      defaultRouteData: {
        description: '',
        real_date: '',
        material_expenses: 0.0,
        viatic_expenses: 0.0,
      },
      routeData: {},
      menu2: true,
      selectedDate: '',
    };
  },
  watch: {
    selectedRoute() {
      let tempDate = '';
      if (this.selectedRoute.real_date) {
        tempDate = moment(String(this.selectedRoute.real_date)).format('DD/MM/YYYY');
      }
      this.selectedDate = this.parseDate(tempDate);
      const retrievedData = {
        description: this.selectedRoute.description,
        real_date: this.selectedDate,
        material_expenses: this.selectedRoute.material_expenses,
        viatic_expenses: this.selectedRoute.viatic_expenses,
        comission_expenses: this.selectedRoute.comission_expenses,
      };
      this.routeData = Object.assign({}, retrievedData);
    },
    selectedDate() {
      this.routeData = Object.assign(this.routeData, {real_date: this.selectedDate});
    },
  },
  methods: {
    async updateRoute() {
      this.axios.put(`/route/${this.selectedRoute.id}`, this.routeData)
      .then((result) => {
        if (result.data.length === 1) {
          this.$emit('success', result.data[0]);
        } else {
          throw Error('Error en el numero de registros actualizados');
        }
      })
      .catch( (error) => {
        this.$emit('error', error.message);
      });
    },
    parseDate(date) {
      if (!date) {
        return null;
      }

      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};
</script>
